// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {Environment} from '../modules/types/interfaces/environment';

export const environment: Environment = {
  type: 'dev',
  production: false,
  plugins: [
    NgxsLoggerPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot()
  ],
  apiUrl: 'https://back.kytd.alzp.tgscloud.net/api',
  oauth2: {
    clientId: '9feb128f-efca-42ff-bbad-b71ac8f86cc9',
    redirectURI: 'https://kytd.alzp.tgscloud.net',
    issuerURI: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e/v2.0',
    wellknownURI: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e/oauth2/v2.0/.well-known/openid-configuration'
  },
  logoutUri: 'https://digitalpassport.hubtotal.net'  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
